module.exports = __webpack_public_path__ + "img/chica.103d77e6.png";